import type { User } from '@/types/user'

/** Typeform form IDs (from mykitchenmate.typeform.com/to/{id}). */
export const TYPEFORM_DOMAIN = 'mykitchenmate.typeform.com'

export const TYPEFORM_BUG_REPORT_ID = 'ZFzITdAM'
export const TYPEFORM_FEATURE_REQUEST_ID = 'zyQsICLN'

/** Hidden fields passed to Typeform (must match hidden fields configured on each form). */
export function getTypeformHiddenFields(
	user: User | null | undefined,
	operatorName?: string
): Record<string, string> | undefined {
	const hidden: Record<string, string> = {}

	if (user?.email) {
		hidden.email = user.email
	}

	if (operatorName) {
		hidden.operator = operatorName
	}

	return Object.keys(hidden).length > 0 ? hidden : undefined
}

export function buildTypeformUrl(formId: string, hidden?: Record<string, string>): string {
	const url = new URL(`https://${TYPEFORM_DOMAIN}/to/${formId}`)

	if (hidden) {
		url.hash = new URLSearchParams(hidden).toString()
	}

	return url.toString()
}
